import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { APP_CONFIG } from '../config/app-config.token';
import { PageMeta } from '@klubovna/shared-models';

@Injectable({
  providedIn: 'root',
})
export class CommonMetaService {
  private meta: Meta = inject(Meta);
  private title: Title = inject(Title);
  private config = inject(APP_CONFIG);

  updateMetaTag(tag: { content: string; name?: string; property?: string }): void {
    this.meta.updateTag(tag);
  }

  setRobotsTag(): void {
    if (this.config.enableSEO) {
      this.meta.updateTag({
        name: 'robots',
        content: 'index, follow',
      });
    } else {
      this.meta.updateTag({
        name: 'robots',
        content: 'noindex, nofollow',
      });
    }
  }

  setPageMeta(pageMeta: PageMeta): void {
    this.title.setTitle(pageMeta.title);

    this.updateMetaTag({
      name: 'description',
      content: pageMeta.description,
    });

    if (pageMeta.keywords) {
      this.updateMetaTag({
        name: 'keywords',
        content: pageMeta.keywords,
      });
    }

    this.updateMetaTag({
      property: 'og:title',
      content: pageMeta.ogTitle || pageMeta.title,
    });

    this.updateMetaTag({
      property: 'og:description',
      content: pageMeta.ogDescription || pageMeta.description,
    });

    if (pageMeta.ogUrl) {
      this.updateMetaTag({
        property: 'og:url',
        content: pageMeta.ogUrl,
      });
    }

    if (pageMeta.ogImage) {
      this.updateMetaTag({
        property: 'og:image',
        content: pageMeta.ogImage,
      });
    }

    if (pageMeta.ogType) {
      this.updateMetaTag({
        property: 'og:type',
        content: pageMeta.ogType,
      });
    }

    if (pageMeta.metaTags) {
      Object.entries(pageMeta.metaTags).forEach(([ key, value ]) => {
        this.updateMetaTag({
          name: key,
          content: value,
        });
      });
    }
  }
}
